import { Switch as RSwitch } from "radix-ui";

import styles from "./Switch.module.css";
import { cx } from "../lib/cx";

export type SwitchProps = {
  // Accessible name for the toggle — required for standalone switches with no
  // adjacent <label>, so screen readers announce what it controls.
  readonly "aria-label"?: string;
  readonly checked: boolean;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly onCheckedChange: (checked: boolean) => void;
};

export const Switch = ({
  "aria-label": ariaLabel,
  checked,
  className,
  disabled,
  onCheckedChange,
}: SwitchProps) => (
  <RSwitch.Root
    aria-label={ariaLabel}
    checked={checked}
    className={cx(styles.switch, className)}
    disabled={disabled}
    onCheckedChange={onCheckedChange}
  >
    <RSwitch.Thumb className={styles.thumb} />
  </RSwitch.Root>
);
